import { render, staticRenderFns } from "./Fandom.vue?vue&type=template&id=e774a716&scoped=true"
import script from "./Fandom.vue?vue&type=script&lang=js"
export * from "./Fandom.vue?vue&type=script&lang=js"
import style0 from "./Fandom.vue?vue&type=style&index=0&id=e774a716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e774a716",
  null
  
)

export default component.exports